import React from "react";

import { StrainTag } from "custom-types/StrainTags";

import IconSvg from "components/IconSvg";
import IconTile from "components/IconTile";

type Props = {
  categories: StrainTag[];
};

const StrainTypeTiles = ({ categories }: Props) => {
  const orderedCategories = () => {
    const orderedList: StrainTag[] = [];
    const correctOrder = ["indica", "sativa", "hybrid"];

    correctOrder.forEach((type) => {
      const eachType = categories.find((e) => e.slug === type);
      if (eachType) {
        orderedList.push(eachType);
      }
    });

    return orderedList;
  };

  return (
    <div className="my-xxl">
      <h2 className="text-md mb-md">Shop weed strains by type</h2>
      <div className="row">
        {orderedCategories().map(({ slug }) => (
          <div key={slug} className="col-1/3">
            <IconTile
              title={slug}
              link={`/strains/lists/category/${slug.toLowerCase()}`}
              eventCategory="Strain List Tile"
              key={slug}
            >
              <IconSvg
                width="40"
                height="40"
                filePath={`phenotypes/${slug}.svg`}
              />
            </IconTile>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StrainTypeTiles;
